import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  Container,
  CssBaseline,
  Stepper,
  Step,
  StepLabel,
  Button,
  Grid,
} from '@mui/material';
import Log from '../../lib/log';
import { useNavigate } from 'react-router-dom';
import SetupUser from '../organisms/SetupUser';
import SetupPayment from '../organisms/SetupPayment';
import SetupIncomingSettings from '../organisms/SetupIncomingSettings';
import SetupTransfer from '../organisms/SetupTransfer';

// ログの初期化
const log = new Log('Setup');

// ステップ
const steps = ['ユーザ設定', '支払情報設定', '着信設定', '設定完了'];

function SetupContent() {
  log.putLog('info', 'Setup started.');

  // ナビゲート
  const navigate = useNavigate();

  // ステップ管理
  const [activeStep, setActiveStep] = useState(0);
  const totalSteps = () => steps.length;
  const isLastStep = () => activeStep === totalSteps() - 1;

  // 次へ
  const [nextDisable, setNextDisable] = useState(true);
  const handleNext = () => {
    if (isLastStep()) {
      return navigate('/Lecture');
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  // 前へ
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleValid = (value: boolean) => {
    setNextDisable(!value);
  };

  return (
    <Container component='main' maxWidth='lg' sx={{ mt: 4, mg: 4 }}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <Grid container justifyContent='center'>
        <Grid item xs={0} md={2} lg={2} />
        <Grid item xs={12} md={8} lg={8}>
          {activeStep === 0 ? (
            <SetupUser valid={(value: boolean) => handleValid(value)} />
          ) : (
            ''
          )}
          {activeStep === 1 ? (
            <SetupPayment valid={(value: boolean) => handleValid(value)} />
          ) : (
            ''
          )}
          {activeStep === 2 ? (
            <SetupIncomingSettings
              valid={(value: boolean) => handleValid(value)}
            />
          ) : (
            ''
          )}
          {activeStep === 3 ? (
            <SetupTransfer valid={(value: boolean) => handleValid(value)} />
          ) : (
            ''
          )}
        </Grid>
        <Grid item xs={0} md={2} lg={2} />
      </Grid>
      {isLastStep() ? (
        <Grid container justifyContent='center'>
          <Grid key='next' item padding={2}>
            <Button
              variant='contained'
              onClick={handleNext}
              disabled={nextDisable}
            >
              完了
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Grid container justifyContent='center'>
          <Grid key='back' item xs={4} textAlign='right' padding={2}>
            <Button
              color='inherit'
              variant='contained'
              disabled={activeStep === 0}
              onClick={handleBack}
            >
              戻る
            </Button>
          </Grid>
          <Grid key='next' item xs={4} padding={2}>
            <Button
              variant='contained'
              onClick={handleNext}
              disabled={nextDisable}
            >
              次へ
            </Button>
          </Grid>
        </Grid>
      )}
    </Container>
  );
}

export default function Setup() {
  return <SetupContent />;
}
